import { render } from "./VideoLog.vue?vue&type=template&id=470e9c1e"
import script from "./VideoLog.vue?vue&type=script&lang=js"
export * from "./VideoLog.vue?vue&type=script&lang=js"

import "./VideoLog.vue?vue&type=style&index=0&id=470e9c1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__